/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

function toObject(object_string) {
  var parameters = {};
  var elements;

  if (!object_string) {
   return {};
  }

 // Split into each element
 elements = object_string.split('&');

 elements.forEach(element => {
   let equals_index = element.indexOf('=');
   // check if the query has a value or is only a key
   if (equals_index == -1) {
     // if there's no = then it's only a key, so set the key to the whole element and the value to null
     // Decode to get original characters
     parameters[decodeURIComponent(element)] = null;
   } else {
     // if there's an = then assign up to the = to be the key and everything after to be the value (or null if empty)
     // Decode to get original characters
     let key = decodeURIComponent(element.slice(0, equals_index));
     let value = decodeURIComponent(element.slice(equals_index + 1)) || null;
     parameters[key] = value;
   }
 })

 return parameters;
}

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  console.log('onCartUpdate',cart);
};

ShopifyAPI.updateCart = function(sections) {
  if (!sections) return;
  var params = {
    type: 'GET',
    url: `${window.shop_api.routes.root}?sections=${sections}`,
    dataType: 'json',
    success: function(data) {
      ShopifyAPI.refreshCart(data);
      timber.RightDrawer.open();
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
}

ShopifyAPI.updateCartNote = function(note, callback) {

  var params = {
    type: 'POST',
    url: `${window.shop_api.routes.cart_update_url}`,
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

const cartSections = {
  'cart': '#CartContainer',
  'cart-modals': '#CartUpsellModalContainer',
  'cart-count': '#CartCount'
}

const renderCartSections = (sections) => {
  for (const name in sections) {
    document.querySelectorAll(cartSections[name]).forEach(entry => {
      entry.innerHTML = sections[name];
    });
  }
}

ShopifyAPI.refreshCart = function(sections) {
  renderCartSections(sections);
}

ShopifyAPI.swapItem = function(key, id, quantity, properties) {

  const data = {
    id: key,
    quantity: 0,
    sections: 'cart,cart-modals,cart-count'
  };

  fetch(window.shop_api.routes.cart_change_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(data => {
    console.log('Swap items success:', data);
    ShopifyAPI.addItemById(id, quantity , properties);
  })
  .catch((error) => {
    console.error('updateItem error:', error);
  });
};

ShopifyAPI.removeItemByKey = function(key) {

  const data = {
    id: key,
    quantity: 0,
    sections: 'cart,cart-modals,cart-count'
  };

  fetch(window.shop_api.routes.cart_change_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(data => {
    console.log('Update items success:', data);
    ShopifyAPI.refreshCart(data.sections);
  })
  .catch((error) => {
    console.error('updateItem error:', error);
  });
};

ShopifyAPI.addItemById = function(id, quantity, properties) {

  const data = {
    items: [
      {
        id,
        quantity,
        properties
      }
    ],
    sections: 'cart,cart-modals,cart-count'
  };

  fetch(window.shop_api.routes.cart_add_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    console.log('Add item success:', data);
    ShopifyAPI.refreshCart(data.sections);
  })
  .catch((error) => {
    console.error('addItem error:', error);
  });
}

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/

var productBundle;
var upsellProducts;

ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {

  // var productBundleData = productBundle();
  var upsellProductsData = upsellProducts(form);

  const data = new FormData(form);
  const formData = Object.fromEntries(data);
  const properties = {};

  for (const key of data.keys()) {
    if (key.startsWith('properties')) {
      properties[key.replace('properties[','').replace(']','')] = formData[key]
    }
  }

  let items = {
    items: [
      {
        id: formData.id,
        quantity: formData.quantity,
        properties: properties
      }
    ]
  };

  if (upsellProductsData) {
    upsellProductsData.forEach(function(upsell) {
      items.items.unshift({
        id: upsell.id,
        quantity: 1,
        properties: {
          _add_on_parent: `${formData['product-id']}`,
          _add_on_discount: upsell.discount
        }
      });
    });
  }

  var params = {
    type: 'POST',
    url: `${window.shop_api.routes.cart_add_url}?sections=cart,cart-modals`,
    data: items,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form, line_item.sections.cart, line_item.sections['cart-modals']);
      } else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      console.info('ERROR',textStatus);
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };

  jQuery.ajax(params);
};

ShopifyAPI.addItemFromButton = function(upsellVariantId, parentVariantId, parentProductId, callback, errorCallback, discountPercent) {

  let parentQuantity = $(`#CartDrawer .ajaxcart__qty input[type="number"][data-id="${parentVariantId}"]`).val();

  var bundleID = parentVariantId.toString() + upsellVariantId.toString();

  var parentLineNumber = $(`#CartDrawer .ajaxcart__qty input[type="number"][data-id="${parentVariantId}"]`).data('line');

  var params = {
    type: 'POST',
    url: `${window.shop_api.routes.cart_change_url}?sections=cart,cart-modals`,
    data: {
      'line': parentLineNumber,
      'quantity': parseInt(parentQuantity),
      'properties': {
        '_parent': bundleID
      }
    },
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart, null, cart.sections.cart, cart.sections['cart-modals']);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
      var parentParams = {
        type: 'POST',
        url: `${window.shop_api.routes.cart_add_url}?sections=cart,cart-modals`,
        data: {
          quantity: parseInt(parentQuantity),
          id: upsellVariantId,
          properties: {
            '_bundle': bundleID,
            '_add_on_parent': parentProductId.toString(),
            '_add_on_discount': discountPercent == '' ? null : discountPercent
          }
        },
        dataType: 'json',
        success: function(line_item) {
          if ((typeof callback) === 'function') {
            callback(line_item, null, line_item.sections.cart, line_item.sections['cart-modals']);
          }
          else {
            ShopifyAPI.onCartUpdate(cart);
          }
        },
        error: function(XMLHttpRequest, textStatus) {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(parentParams);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);

};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON(`${window.shop_api.routes.cart_url}`, function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: `${window.shop_api.routes.cart_change_url}?sections=cart,cart-modals`,
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart, cart.sections.cart, cart.sections['cart-modals']);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart, quickAddItem;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, validateBundle, validateCart, bundleQuantity, reduceBundledQuantity, buildCartSection, refreshCartModals;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      // qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    // if (!settings.disableAjaxCart && $addToCart.length) {
    //   formOverride();
    // }
    formOverride();

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
    validateCart();
  };

  //
  // Product Bundle function from Diff Agency
  // 

  productBundle = function () {
    var bundleInputs = Array.from(document.querySelectorAll('.js-uspPromo__variant-checkbox'));

    const checkedInput = bundleInputs.filter(function(input) {
      return input.checked;
    })

    if (checkedInput[0]) {
      var data = { variantId: checkedInput[0].dataset.variantId, variantTitle: checkedInput[0].dataset.variantTitle, variantLineAttribute: checkedInput[0].dataset.attribute }
      return data
    }
  };

  //
  // End - Product Bundle function from Diff Agency (UPDATED BY KJ 12/8/23)
  //

  upsellProducts = function(form) {

    const upsellInputs = Array.from(form.querySelectorAll('[data-add-on]'));

    if (upsellInputs) {
      return upsellInputs.map(input => {
        if (input.checked) {
          const inputId = input.dataset.addOn;
          const upsellDiscount = input.dataset.addOnDiscount == "" ? null : input.dataset.addOnDiscount;
          const selectedVariant = form.querySelector(`[data-upsell-variant-input="${inputId}"]:checked`).value;
          return {
            id: selectedVariant,
            discount: upsellDiscount 
          };
        } else {
          return null;
        }
      }).filter(input => input !== null);
    } else {
      return false;
    }
  };

  quickAddItem = function (upsellVariantId,parentVariantId,parentProductId,discountPercent) {
    ShopifyAPI.addItemFromButton(upsellVariantId,parentVariantId,parentProductId,itemAddedCallback,itemErrorCallback,discountPercent);
  }

  loadCart = function () {
    // $body.addClass('drawer--is-loading');
    // ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
	  if ($cartCountSelector) {
	    $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
	
	    if (cart.item_count === 0) {
	      $cartCountSelector.addClass('hidden-count');
	    }
	  }
	  if ($cartCostSelector) {
	    $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
	  }
	};

  formOverride = function () {
    $body.on('submit', $formContainer, function(evt) {

      if (!evt.target.action.includes('/cart/add')) return;

      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product, form, cartSection, cartModals) {
    if (!!$addToCart) {
      $addToCart.removeClass('is-adding').addClass('is-added');
    }
    ShopifyAPI.getCart(cartUpdateCallback);
    buildCartSection(cartSection);
    refreshCartModals(cartModals);
    console.log('ITEM ADDED CALLBACK')
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  buildCartSection = function (cartSection) {
    $cartContainer.html(cartSection);
  };

  refreshCartModals = function (cartModals) {
    $('#CartUpsellModalContainer').html(cartModals);
  };

  cartUpdateCallback = function (cart) {
    const event = new CustomEvent("cart:change", { detail: cart });
    document.dispatchEvent(event);
    // Update quantity and price
    updateCountPrice(cart);
    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
    // Bold:POv2
    if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
      typeof BOLD.common.eventEmitter.emit === 'function'){
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', cart);
        
        var moneyEls = Array.from(document.querySelectorAll('.js-container-bundle-dropdown .money'));
        
        moneyEls.forEach(function(money) {
          if (money.childNodes[1]) {
            money.childNodes[1].remove();
          }
        }); 
        console.log('cartCallback bold', true);
      }
      // Bold:POv2
      setTimeout(function() {
        validateBundle(cart);
        bundleQuantity(cart);
      }, 500);
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function(e) {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num, .js-ajax-bundle-update'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
        return false;
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('input', '.ajaxcart__qty-num', function() {
      $('.cart__checkout').prop("disabled", true);
      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));
      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      } else {
        $('.cart__checkout').prop("disabled", false);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    $body.on('input', '.js-ajax-bundle-update', function (e) {
      removeBundleItem(e.currentTarget);
    });
    
    $body.on('click', '.js-ajax-bundle-qty-adjust', function (e) {
      adjustBundleItem(e.currentTarget);
    });

    var adjustBundleItem = function(el) {
      var $el = $(el);
      var line = $el.data('line');
      var bundleID = $el.data('bundle');
      var key = $el.data('key');
      var $qtySelector = $el.siblings('.js-ajax-bundle-update');
      var qty = parseInt($qtySelector.val().replace(/\D/g, ''));
      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line && key && qty === 0) {
        $.get(`${window.shop_api.routes.cart_json}`).then(function(cart){
          let items = cart.items;
          let childItems = items.filter(function(item){ return (item.properties && item.properties['_bundle'] == bundleID); });
          let update_items = {};
          update_items[key] = qty; //parent

          childItems.forEach(function (item,index) {
            update_items[item.key] = 0; //child
          });
  
          $.post(window.shop_api.routes.cart_update_url, { updates: update_items }).done(function(cart){
            adjustCartCallback(cart);
          });
        });
      } else if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    }

    var removeBundleItem = function(el) {
      $('.cart__checkout').prop('disabled', true);
      var $el = $(el),
          line = $el.data('line'),
          bundleID = $el.data('bundle'),
          key = $el.data('key'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line && key) {
        $.get(`${window.shop_api.routes.cart_json}`).then(function(cart){
          let items = cart.items;
          let childItems = items.filter(function(item){ return (item.properties && item.properties['_bundle'] == bundleID); });
          let update_items = {};
          update_items[key] = qty;

          childItems.forEach(function (item,index) {
            var childitem_qty = item.quantity;
            if (qty < childitem_qty && qty > 0) {
              update_items[item.key] = qty;
            } else if(qty == 0) {
              update_items[item.key] = 0;
            }
          });

          $.post(window.shop_api.routes.cart_update_url, { updates: update_items }).done(function(cart){
            adjustCartCallback(cart);
          });
        });
      }
    }

    bundleQuantity = function () {
      const cartItemElements = Array.from(document.querySelectorAll('.ajaxcart__qty-num, .js-ajax-bundle-update'));

      if (!cartItemElements.length) return;
      
      // Get Elements
      const bundleChildrenElements = cartItemElements.filter(function(el) { return el.getAttribute('properties') });

      if (!bundleChildrenElements.length) return;
      //bundledInputElements = cartItemElements.filter(function(el) { return (el.getAttribute('properties') && el.getAttribute('properties') == MainInputElements[0].getAttribute('data-bundle'))})

      bundleChildrenElements.forEach(function (bundledInputElements,index) {
        const MainInputElements = cartItemElements.filter(function(el) { 
          var parent = el.closest('.ajaxcart__product').querySelector('.js-ajax-bundle-update');
          var child = bundledInputElements.closest('.ajaxcart__product').querySelector('.ajaxcart__qty-num');
          return (
            // return element that doesn't have a properties and that the product name is equal to the product bundle property
            !el.getAttribute('properties') && parent && child && parent.dataset.bundle === child.getAttribute('properties')
          )
        });

        // Get Increment Btns from Bundled Items
        const bundledItemIncrementBtns = bundledInputElements.parentElement.querySelector('.ajaxcart__qty--plus');
        // Get Quantity per Element
        const bundledItemsQuantity = parseInt(bundledInputElements.value);
        const MainItemQuantity = MainInputElements.map(function(el) { return +el.value });
        // Get total quantity of combined element quantity
        let bundledItemsTotalQuantity = 0;

        let MainItemTotalQuantity = 0;
        MainInputElements.forEach(function(el){
          MainItemTotalQuantity += parseInt(el.value);
        })
        // for (let quantity of MainItemQuantity)
        //   MainItemTotalQuantity += +quantity;    
        // If Cart has more or = bunbled products then main products, disabled increment btns

        if (MainItemTotalQuantity === bundledItemsQuantity) {    
            bundledItemIncrementBtns.disabled = true
            bundledItemIncrementBtns.classList.add('is-disabled');
        } else if (MainItemTotalQuantity < bundledItemsQuantity && MainItemTotalQuantity > 0) {  
          bundledItemIncrementBtns.disabled = true
          bundledItemIncrementBtns.classList.add('is-disabled');
          reduceBundledQuantity(bundledInputElements, MainItemTotalQuantity, bundledItemsQuantity)
        } else if(MainItemTotalQuantity === 0){ 
          const checkout_btn = document.querySelector('.ajaxcart__footer .cart__checkout');
          if(checkout_btn){
            checkout_btn.dsiabled = true;
            checkout_btn.classList.add('is-disabled');
          }
          reduceBundledQuantity(bundledInputElements, MainItemTotalQuantity, bundledItemsQuantity)
        } else {         
            bundledItemIncrementBtns.disabled = false
            bundledItemIncrementBtns.classList.remove('is-disabled');
        }
      });
    };

    reduceBundledQuantity = function (bundledInputElements, MainItemTotalQuantity, bundledItemsTotalQuantity) {
      const bundledItemDataLine = bundledInputElements.dataset.line;
      const quantityToAdjust = MainItemTotalQuantity - (bundledItemsTotalQuantity - bundledInputElements.value);

      bundledInputElements.value = quantityToAdjust;

      ShopifyAPI.changeItem(bundledItemDataLine, quantityToAdjust, adjustCartCallback);
    }

    validateBundle = function (cart) {
      var cartFlyoutProducts = Array.from(document.querySelectorAll('.ajaxcart__product'));

      var bundledProducts = cart.items.filter(function(item) {
        return item.properties;
      });

      if (!bundledProducts.length) return;

      bundledProducts.forEach(function(product) {

        var bundleId = product.variant_id
        
        var domBundleProducts = cartFlyoutProducts.filter(function(p) {
          return p.classList.contains('ajaxcart__qty-num') && +p.querySelector('.ajaxcart__qty-num').getAttribute('data-id') == bundleId && p.querySelector('.ajaxcart__qty-num').getAttribute('properties')
        });

        if (!domBundleProducts.length) return;

        var bundleLine = domBundleProducts[0].querySelector('.ajaxcart__qty-num').getAttribute('data-line');

        var requiredProductForBundle = cartFlyoutProducts.filter(function(item) {
          return item.querySelector('.ajaxcart__qty-num').dataset.bundle === product.properties._bundle
        });

        if (!requiredProductForBundle.length) {
          updateQuantity(bundleLine, 0);
        }
      });      
    }

    validateCart = function () {
      const cartItems = Array.from(document.querySelectorAll('.productItem'));

      if (!cartItems.length) return;

      const domBundleProducts = cartItems.filter(function(product) {
        return product.dataset.properties
      });

      if (!domBundleProducts.length) return;
      domBundleProducts.forEach(function(bundleProduct) {

        const requiredItems = cartItems.filter(function(product) {
          return product.dataset.bundle === bundleProduct.dataset.properties
        })
        
        // if no required item is present in cart, also delete bundle items
        if (!requiredItems.length) bundleProduct.querySelector('.remove a').click();

        var adjust = function (total) {
          const bundleItemsQuantity = +bundleProduct.querySelector('.quantity input').value;
          let requiredItemsQuantity = +requiredItems[0].querySelector('.quantity input').value;

          if (total) requiredItemsQuantity = total
  
          if (bundleItemsQuantity >= requiredItemsQuantity) {
            const domBundleItem = bundleProduct.querySelector('input');
            const quantityToAdjust = bundleItemsQuantity - (bundleItemsQuantity - requiredItemsQuantity);
  
            domBundleItem.value = quantityToAdjust;
          }
        }

        var recalculateCart = function() {
          setTimeout(() => {
            // calculate new inputed quantity
            const cartItems = Array.from(document.querySelectorAll('.productItem'));
            if (!cartItems.length) return;
    
            const requiredItems = cartItems.filter(function(product) {
              return product.dataset.bundle === bundleProduct.dataset.properties
            })
    
            const requiredItemsQuantity = +requiredItems[0].querySelector('.quantity input').value;

            adjust(requiredItemsQuantity);
    
          }, 300);
        }

        cartItems.forEach(function(item) {
          // item.querySelector('input').addEventListener('change', recalculateCart);
          item.querySelector('input').addEventListener('input', recalculateCart);
        });
  
        adjust();

      });
    };
    

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });

  };

  adjustCartCallback = function (cart, cartSection, cartModals) {
    const event = new CustomEvent("cart:change", { detail: cart });
    document.dispatchEvent(event);
    isUpdating = false;
    $('.cart__checkout').prop("disabled", false);
    // Update quantity and price
    updateCountPrice(cart);
    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
      buildCartSection(cartSection);
      refreshCartModals(cartModals);
    }, 150);
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var readOnly = "";
        if(this.getAttribute('readonly') == 'readonly'){
         readOnly = "disabled='disabled'"; 
        }
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              readOnly:readOnly,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
        validateCart();
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart,
    quickAdd: quickAddItem
  };

  return module;

}(ajaxCart || {}, jQuery));